<template>
  <div>
    <div style="height: 2px; background-color:#f2f2f2; width: 100%;"></div>
    <div v-if="mensajes">
      <ItemChat
        :titulo='partidoDescription'
        :cantidadRespuestas="chat.length"
        :detail-id="partidoId"
        :mensajes="mensajes"
        @clickDetalleChat="$emit('goDetailChat', arguments[0], arguments[1])">
      </ItemChat>
    </div>

    <div style="display: flex; justify-content: center; align-items: center; gap: 8px; margin-top: 15px;" v-else>
      <v-icon>chat_bubble</v-icon>
      <span>No hay un chat para este partido</span>
    </div>
  </div>
</template>

<script>
import ItemChat from './ItemChat.vue'
export default {
  data () {
    return {
      fecha: null,
      hora: null,
      chat: []
    }
  },
  components: {
    ItemChat
  },
  props: {
    autor: null,
    createdAt: null,
    clubId: null,
    partido: null,
    partidoId: null,
    departamento: null,
    estado: null,
    detailId: null,
    reportType: null,
    cardType: null,
    modified: null,
    titulo: null,
    localData: null,
    visitorData: null,
    partidoDescription: null,
    mensajes: null
  },
  methods: {
    goDetail () {
      this.$router.push({ name: 'informe-auditoria', params: { id: this.detailId } })
    },
    formatDateTime () {
      let dateTime = this.createdAt.split('T')
      this.fecha = dateTime[0]
      const [dia, mes, anio] = this.fecha.split('-')
      this.fecha = `${anio}-${mes}-${dia}`
      this.hora = dateTime[1].split('.')[0]
    }
  },
  created () {
    this.fetchChat()
  }
}
</script>

<style scoped>
.tarjeta {
  background-color: #eeeeee;
  width: 90%;
  height: 60px;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  overflow: hidden;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);
  margin: 20px auto;
}

span {
  font-size: 1.2em;
  color: #293968;
}

.container-titulo-informe,
.container-autor {
  justify-items: center;
}

.container-autor {
  margin-right: 20px;
}

.container-titulo-informe {
  margin-left: 20px;
}

.tarjeta-selection {
  margin-right: 20px;
  cursor: pointer;
}

.container-buttons {
  align-content: center;
  display: flex;
  justify-content: center;
}
</style>
